import { Navigate, Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/brand/Logo";

export const FullPageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-lasso-paper" data-testid="page-loader">
    <div className="flex flex-col items-center gap-5 animate-pulse">
      <Logo size="lg" showHub={false} />
      <span className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Loading</span>
    </div>
  </div>
);

export const NotAuthorized = () => (
  <div className="mx-auto max-w-lg py-24 text-center" data-testid="not-authorized">
    <ShieldAlert className="mx-auto h-10 w-10 text-lasso-deep" />
    <h1 className="mt-6 font-display text-2xl font-bold">Access restricted</h1>
    <p className="mt-3 text-muted-foreground">Your role doesn't have permission to view this page.</p>
    <Link to="/dashboard" className="mt-8 inline-block text-sm font-semibold underline underline-offset-4" data-testid="not-authorized-home-link">
      Back to dashboard
    </Link>
  </div>
);

export function ProtectedRoute({ roles, children, regionAdmin, superOnly }) {
  const { user } = useAuth();
  if (user === null) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && !(regionAdmin && user.is_region_admin)) return <NotAuthorized />;
  if (superOnly && !user.is_super) return <NotAuthorized />;
  return children;
}
